import { Show } from "solid-js"
import { twMerge } from "tailwind-merge"

export const PromoSaleContainer = (props) => {
  return (
    <div 
      class="policyText flex items-center"
      classList={{
        "mt-1": props.compact != true
      }}
    >
      <div class="flex w-auto cursor-pointer justify-between gap-1 rounded-xl font-regular text-sm text-ink items-center">
        <Show when={props.discountedPrice}>
          <div
            class="py-1 font-bold text-sale-700"
            classList={{
              "text-sm": props.compact == true,
              "text-base": props.compact != true
            }}
          >{props.discountedPrice}</div>
        </Show>
        <div 
          class="flex items-center rounded-lg bg-sale-600 font-bold text-canvas py-0.5 px-1"
          classList={{
            "gap-0.5 text-sm": props.compact == true,
            "gap-1 text-base": props.compact != true
          }}
        >
          <Show when={props.image}>
            <div>
              <img classList={{
                "w-2 h-2": props.compact == true,
                "w-3 h-3": props.compact != true
              }} src={props.image} />
            </div>
          </Show>
          <div class={twMerge("text-xs", props.textClass ?? '')}>{props.text}</div>
        </div>
      </div>
    </div>
  )
}